// extracted by mini-css-extract-plugin
export default {"waterDownModal":"WaterDownModal_waterDownModal__SyIRw"};